import { requestRaw } from "./http/apiClient";

const ENDPOINT = "/v1/accountmanager/createcomplianceaccount";

function buildFormData(payload) {
  const fd = new FormData();
  Object.entries(payload).forEach(([k, v]) => {
    if (v !== undefined && v !== null) fd.append(k, v);
  });
  return fd;
}

async function create(data) {
  const formData = buildFormData(data);

  const { ok, status, text } = await requestRaw({
    path: ENDPOINT,
    method: "POST",
    body: formData,           
    casing: "title",          
    includeAuth: true,
    accept: "application/json",
    contentType: undefined,   
  });

  if (!ok) throw new Error(`HTTP ${status}: ${text || "Server Error"}`);

  try {
    return JSON.parse(text || "{}");
  } catch {
    return text;
  }
}

const IuguOnboardingService = { create };
export default IuguOnboardingService;

